module.exports = __webpack_public_path__ + "static/ca096842.banner_title_en.png";